import React from 'react'
import { categories } from './Data/Data'
function Category() {
  return (
    <div className='max-w[1640px] mx-auto px-4 py-12'>
      <h1 className='text-orange-600 font-bold text-4xl text-center'> Top Rated Menu Items</h1>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-6  py-6'>
        {
            categories.map((item,index)=>(
                <div className='bg-gray-100 rounded-lg  py-4 flex justify-between items-center' key={index}>
                    <h2 className='font-bold sm:text-xl'>{item.name}</h2>
                    <img src={item.image} alt='/'/>

                </div>
            ))
        }
      </div>
    </div>
  )
}

export default Category
